module.exports = __webpack_public_path__ + "static/gladly-logo-7d145f0402a1dc5855dcf2a43635d952.png";